var map = {
	"./aqua@3x.png": 77658,
	"./blue@3x.png": 25734,
	"./cyan@3x.png": 15729,
	"./darkMagenta@3x.png": 21893,
	"./darkOrange@3x.png": 60968,
	"./darkRed@3x.png": 19637,
	"./deepPink@3x.png": 24156,
	"./forestGreen@3x.png": 35114,
	"./gold@3x.png": 60576,
	"./greenSea@3x.png": 16276,
	"./magenta@3x.png": 35097,
	"./orange@3x.png": 61164,
	"./pink@3x.png": 18278,
	"./red@3x.png": 71681,
	"./residence@3x.png": 26186,
	"./skyBlue@3x.png": 99767,
	"./yellowGreen@3x.png": 82133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76494;